import React from "react";

const DS = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Data Skills</h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Data Cleaning</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Data Processing</h3>
              <span className="skills__level">Proficient</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">EDA</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          {/* Add more skills if needed */}
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Data Visualization</h3>
              <span className="skills__level">Proficient</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Feature Engineering</h3>
              <span className="skills__level">Proficient</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Prompt Engineering</h3>
              <span className="skills__level">Advanced</span>
            </div>
          </div>
          {/* Add more skills if needed */}
        </div>
      </div>
    </div>
  );
};

export default DS;
